import { render, staticRenderFns } from "./CreatePurchasePayment.vue?vue&type=template&id=732d9bc5"
import script from "./CreatePurchasePayment.vue?vue&type=script&lang=js"
export * from "./CreatePurchasePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports